<template>
  <a-modal :visible="visible" title="交班对账（F12）" :maskClosable="false" width="860px"
           okText="打印" cancelText="关闭" @ok="print" @cancel="$emit('cancel')">
    <div class="shift-toolbar">
      <span>时段：</span>
      <a-date-picker v-model="beginDate" format="YYYY-MM-DD" style="width: 140px" />
      <span>至</span>
      <a-date-picker v-model="endDate" format="YYYY-MM-DD" style="width: 140px" />
      <a-button type="primary" size="small" @click="load">查询</a-button>
      <span class="shift-tip">默认今日 00:00 ~ 现在</span>
    </div>
    <div ref="printArea" class="shift-report">
      <div class="report-title">交班对账单（{{ cashierName }}）</div>
      <div class="report-range">{{ report.beginTime || '' }} ~ {{ report.endTime || '' }}</div>
      <div class="sum-cards">
        <div class="sum-card"><div class="sum-num">{{ report.salesCount || 0 }}</div><div class="sum-label">销售单数</div></div>
        <div class="sum-card"><div class="sum-num">¥{{ format(report.salesTotal) }}</div><div class="sum-label">销售金额</div></div>
        <div class="sum-card"><div class="sum-num">{{ report.returnCount || 0 }}</div><div class="sum-label">退货单数</div></div>
        <div class="sum-card"><div class="sum-num">¥{{ format(report.returnTotal) }}</div><div class="sum-label">退货金额</div></div>
        <div class="sum-card main"><div class="sum-num">¥{{ format(report.netTotal) }}</div><div class="sum-label">实收净额</div></div>
      </div>
      <a-tabs size="small">
        <a-tab-pane tab="收款汇总" key="sales">
          <a-table :columns="payColumns" :dataSource="report.sales || []" :pagination="false"
                   size="small" rowKey="payType" />
        </a-tab-pane>
        <a-tab-pane tab="退款汇总" key="returns">
          <a-table :columns="payColumns" :dataSource="report.returns || []" :pagination="false"
                   size="small" rowKey="payType" />
        </a-tab-pane>
        <a-tab-pane tab="流水明细" key="details">
          <a-table :columns="detailColumns" :dataSource="report.details || []" :pagination="false"
                   size="small" rowKey="number" :scroll="{ y: 300 }" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { cashierShiftReport } from '@/api/plugin/member'

  /**
   * 交班弹窗：时段选择 + 销售收款/退款汇总 + 流水明细，支持浏览器打印
   */
  export default {
    name: 'ShiftModal',
    props: {
      visible: { type: Boolean, default: false }
    },
    data() {
      return {
        beginDate: null,
        endDate: null,
        report: {},
        payColumns: [
          { title: '支付方式', dataIndex: 'payType' },
          { title: '单数', dataIndex: 'cnt', width: 100 },
          { title: '金额', dataIndex: 'amount', width: 140, customRender: t => '¥' + this.format(t) }
        ],
        detailColumns: [
          { title: '单号', dataIndex: 'number', width: 170 },
          { title: '类型', dataIndex: 'subType', width: 90, customRender: t => t === '零售' ? '销售' : '退货' },
          { title: '支付方式', dataIndex: 'payType', width: 110 },
          { title: '金额', dataIndex: 'totalPrice', width: 110, customRender: t => '¥' + this.format(t) },
          { title: '时间', dataIndex: 'operTime', width: 160 }
        ]
      }
    },
    computed: {
      ...mapGetters(['userInfo']),
      cashierName() {
        const info = this.userInfo || {}
        return info.username || info.realname || '收银员'
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.beginDate = moment().startOf('day')
          this.endDate = moment()
          this.load()
        }
      }
    },
    methods: {
      format(price) {
        return Number(price || 0).toFixed(2)
      },
      load() {
        const params = {}
        if (this.beginDate) {
          params.beginTime = this.beginDate.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        if (this.endDate) {
          params.endTime = this.endDate.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        cashierShiftReport(params).then(res => {
          if (res && res.code === 200) {
            this.report = res.data || {}
          } else {
            this.$message.warning((res && res.message) || '查询失败')
          }
        })
      },
      print() {
        const area = this.$refs.printArea
        if (!area) return
        const win = window.open('', '_blank')
        win.document.write(`<html><head><title>交班对账单</title></head><body>${area.innerHTML}</body></html>`)
        win.document.close()
        win.print()
      }
    }
  }
</script>

<style scoped>
  .shift-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }
  .shift-tip {
    color: #999;
    font-size: 12px;
  }
  .report-title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .report-range {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin: 4px 0 12px;
  }
  .sum-cards {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .sum-card {
    flex: 1;
    background: #f8f9fa;
    border-radius: 6px;
    padding: 10px 0;
    text-align: center;
  }
  .sum-card.main {
    background: #0081ff;
  }
  .sum-card.main .sum-num,
  .sum-card.main .sum-label {
    color: #fff;
  }
  .sum-num {
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
  .sum-label {
    color: #999;
    font-size: 12px;
    margin-top: 2px;
  }
</style>
